module.exports = __webpack_public_path__ + "img/BGMain9.1ef986ee.jpg";